import { render, staticRenderFns } from "./CountrySelection.vue?vue&type=template&id=5878f234"
import script from "./CountrySelection.vue?vue&type=script&lang=js"
export * from "./CountrySelection.vue?vue&type=script&lang=js"
import style0 from "./CountrySelection.vue?vue&type=style&index=0&id=5878f234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports